import React from "react";

function ClientId ({ clientInfo }) {
    return (
        <div>
            {!clientInfo['identity'] && clientInfo['passport'] 
                ? (
                    <span style={{ marginLeft: '1rem' }}>
                        <strong>דרכון:</strong> {clientInfo['passport']}
                    </span>
                ) 
                : (
                    <span style={{ marginLeft: '1rem' }}>
                        <strong>ת.ז:</strong> {clientInfo['identity'] || "-"}
                    </span>
                )}
        </div>
    )
}

export default ClientId